module.exports = __webpack_public_path__ + "static/Marianos_pin-cda8ae813db3b1ce9bb01272f696d600.png";